<template>
	<v-sheet color="body-container" :class="{
		'fill-height d-flex flex-column': showSidebar,
		}" v-bind="$attrs" v-on="$listeners">
		<slot name="prepend"></slot>
		<v-container v-if="showSidebar" :class="{
			'pa-0 fill-height': true,
			'px-6 py-12 pa-print-0': !showSidebar && $vuetify.breakpoint.mdAndUp,
		}">
			<v-row no-gutters class="fill-height">
				<v-col class="d-print-none" :cols="_sidebarAttrs.cols || 12" :md="_sidebarAttrs.md || 4" :lg="_sidebarAttrs.lg || 3" :xl="_sidebarAttrs.xl || 3" v-bind="sidebarAttrs" style="position: relative">
					<v-sheet class="fill-height">
						<Sticky class="py-6">
							<slot name="sidebar">
								<Categories v-model="navigableTags" :skeleton="$root.tags === null" />
							</slot>
						</Sticky>
					</v-sheet>
				</v-col>
				<v-col :cols="_contentAttrs.cols || 12" :md="_contentAttrs.md || 8" :lg="_contentAttrs.lg || 9" :xl="_contentAttrs.xl || 9" v-bind="contentAttrs" class="px-6 py-12">
					<ComboNotification v-if="showComboNotification" :combos.sync="combos" textDecorationUnderline fontWeightBold :textH5="isDesktopBreakpoint" :textH6="!isDesktopBreakpoint" :height="isDesktopBreakpoint ? 46 : 48"/>

					<v-container class="py-0 d-print-none">
						<Breadcrumbs v-if="breadcrumbs" class="pa-0 mb-2"/>
					</v-container>

					<slot></slot>

					<!-- TOP OF THE PAGE -->
					<div v-if="!noTopPage" class="text-center mt-12 d-print-none">
						<GoBackUp />
					</div>
				</v-col>
			</v-row>
		</v-container>
		<template v-else>
			<ComboNotification v-if="showComboNotification" :combos.sync="combos" textDecorationUnderline fontWeightBold :textH5="isDesktopBreakpoint" :textH6="!isDesktopBreakpoint" :height="isDesktopBreakpoint ? 46 : 48"/>
			<Breadcrumbs v-if="breadcrumbs" class="md-md-2" />

			<slot></slot>

		</template>
	</v-sheet>
</template>


<script>
import Categories from './Categories';
import GoBackUp from '@/components/GoBackUp'
import Breadcrumbs from '@/components/Breadcrumbs'
import Sticky from '@/components/Sticky'
import { CartModel, EventBus, PaginationModel } from '@connectngo/sdk'
import ComboNotification from '@/components/ComboNotification'
import ComboModal from '@/components/Modals/ComboModal'
import globalVariables from '@/global'
import InteractiveMapCrossSellModal from "@/components/InteractiveMap/InteractiveMapCrossSellModal";
import EcomReskinMixin from '@/mixins/EcomReskinMixin'

export default {
	name: 'Page',

	components: {InteractiveMapCrossSellModal, ComboModal, ComboNotification, Categories, GoBackUp, Breadcrumbs, Sticky },
	mixins : [EcomReskinMixin],

	props: {
		noSidebar: {
			type: Boolean,
			default: false,
		},
		noTopPage: {
			type: Boolean,
			default: false,
		},
		breadcrumbs: {
			type: Boolean,
			default: false,
		},
		contentAttrs: {
			type: Object,
			default: () => ({}),
		},
		sidebarAttrs: {
			type: Object,
			default: () => ({}),
		},
		forceShowingSidebar: {
			type: Boolean,
			default: false,
		},
		showCombos: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	data: () => ({
		combos: [],
		comboUpdatedEventBus: null,
		ffCombo: false,
	}),

	computed: {
		showSidebar() {
			return !this.noSidebar && this.$vuetify.breakpoint.mdAndUp
				&& (
					(this.$root.tags !== null && this.navigableTags.results.length > 0)
					|| this.$slots.sidebar
				);
		},
		navigableTags() {
			return new PaginationModel(this.$root.tags.results.filter(result => {
				return result.data.navigable;
			}));
		},
		_contentAttrs() {
			return !this.$slots.sidebar && this.navigableTags.results.length === 0 ? {
				cols: 12,
				md: 12,
				lg: 12,
				xl: 12,
			} : this.contentAttrs;
		},
		_sidebarAttrs() {
			return !this.$slots.sidebar && this.navigableTags.results.length === 0 ? {
				cols: 12,
				md: 12,
				lg: 12,
				xl: 12,
			} : this.sidebarAttrs;
		},
		isDesktopBreakpoint() {
			return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl || this.$vuetify.breakpoint.md
		},
		showComboNotification() {
			return this.ffCombo && this.showCombos && this.combos.length > 0;
		},
	},
	mounted() {
		if(this.ffCombo) {
			let ref = this;
			this.comboUpdatedEventBus = EventBus.subscribe('COMBO_UPDATED', function (combos) {
				ref.combos = combos;
			});
		}
	},
	created() {
		if (this.$root.combos.length > 0) {
			this.combos = this.$root.combos;
		}

		this.ffCombo = globalVariables.websiteConfig.featureFlagEnabled('combo-v2');
	},
	destroyed () {
		if (this.ffCombo) {
			this.comboUpdatedEventBus.unsubscribe()
		}
	},
}
</script>

<style lang="scss">
	.body-container {
		background-color: $grey-lighter !important;
		padding: 10px 20px 35px 20px;
	}
	@media (max-width: 600px) {
		.body-container {
			padding: 10px 0px 0px 0px !important;
		}
	}
</style>
